import React, { useContext, useRef, useState } from "react";
import "./Contact.css";
import emailjs from "@emailjs/browser";
import { themeContext } from "../../Context";

const Contact = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  const form = useRef();
  const [done, setDone] = useState(false);
  const [errors, setErrors] = useState({}); // State for validation errors
  const [formData, setFormData] = useState({
    user_name: "",
    user_email: "",
    message: "",
  });

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" }); // Clear errors on change
  };

  // Form validation
  const validateForm = () => {
    let newErrors = {};
    if (!formData.user_name.trim()) newErrors.user_name = "Name is required";
    if (!formData.user_email.trim()) {
      newErrors.user_email = "Email is required";
    } else if (!/^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/.test(formData.user_email)) {
      newErrors.user_email = "Invalid email format";
    }
    if (!formData.message.trim()) newErrors.message = "Message cannot be empty";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Returns true if no errors
  };

  const sendEmail = (e) => {
    e.preventDefault();
    if (!validateForm()) return; // Stop submission if validation fails

    emailjs
      .sendForm(
        "service_nwiyqho",
        "template_o35u4uh",
        form.current,
        "a1KD_929rp7ggwEaV"
      )
      .then(
        (result) => {
          console.log(result.text);
          setDone("Thanks for contacting me!");
          setFormData({ user_name: "", user_email: "", message: "" });
        },
        (error) => {
          console.log(error.text);
        }
      )
      .finally(() => {
        setTimeout(() => {
          setDone(false);
        }, 4000);
        form.reset();
      });
  };

  return (
    <div className="contact-form" id="contact">
      <div className="w-left">
        <div className="awesome">
          <span style={{ color: darkMode ? "white" : "" }}>Get in Touch</span>
          <span>Contact me</span>
          <div className="blur s-blur1" style={{ background: "#ABF1FF94" }}></div>
        </div>
      </div>
      <div className="c-right">
        <form ref={form} onSubmit={sendEmail}>
          <input
            type="text"
            name="user_name"
            className="user"
            placeholder="Name"
            value={formData.user_name}
            onChange={handleChange}
          />
          {errors.user_name && <span className="error">{errors.user_name}</span>}

          <input
            type="email"
            name="user_email"
            className="user"
            placeholder="Email"
            value={formData.user_email}
            onChange={handleChange}
          />
          {errors.user_email && <span className="error">{errors.user_email}</span>}

          <textarea
            name="message"
            className="user"
            placeholder="Message"
            value={formData.message}
            onChange={handleChange}
          />
          {errors.message && <span className="error">{errors.message}</span>}

          <input type="submit" value="Send" className="button" />
          <span>{done && done}</span>

          <div className="blur c-blur1" style={{ background: "var(--purple)" }}></div>
        </form>
      </div>
    </div>
  );
};

export default Contact;
